import { handleApiResponse } from './api.utils';
import API_CONFIG from '../../config/api.config';
import apiClient from './apiClient';

interface Role {
  idRole: number;
  roleName: string;
  description: string;
}

interface User {
  idUser: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: Role[];
}

interface GetUsersResponse {
  status: string;
  users: User[];
  count: number;
  execution_time_seconds: number;
}

interface GetUsersParams {
  statusUser?: number;
  role_id?: number;
}

class UsersService {
  private static instance: UsersService;
  private cache: Map<string, { data: GetUsersResponse; timestamp: number }> = new Map();
  private readonly CACHE_TTL = 5 * 60 * 1000; // 5 minutes

  private constructor() {}

  public static getInstance(): UsersService {
    if (!UsersService.instance) {
      UsersService.instance = new UsersService();
    }
    return UsersService.instance;
  }

  private getCacheKey(params: GetUsersParams): string {
    return JSON.stringify(params);
  }

  public async getUsers(params: GetUsersParams = {}, useCache: boolean = true): Promise<GetUsersResponse> {
    try {
      const cacheKey = this.getCacheKey(params);
      
      // Check cache if useCache is true
      if (useCache) {
        const cached = this.cache.get(cacheKey);
        if (cached && Date.now() - cached.timestamp < this.CACHE_TTL) {
          return cached.data;
        }
      }

      // Build query string
      const queryParams = new URLSearchParams();
      if (params.statusUser !== undefined) {
        queryParams.append('statusUser', params.statusUser.toString());
      }
      if (params.role_id !== undefined) {
        queryParams.append('role_id', params.role_id.toString());
      }

      const queryString = queryParams.toString();
      const url = `${API_CONFIG.BASE_URL}/stoc/async/users${queryString ? `?${queryString}` : ''}`;

      const endpoint = url.replace(API_CONFIG.BASE_URL, '');
      const data = await apiClient.get(endpoint) as GetUsersResponse;

      // Update cache
      if (useCache) {
        this.cache.set(cacheKey, {
          data,
          timestamp: Date.now()
        });
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default UsersService.getInstance(); 